<template>
  <div id="profile" class="vs-con-loading__container">
    <vx-card class="mt-base w-full md:w-3/4 m-auto" no-shadow card-border>
      <div>
        <div class="flex items-center">
          <feather-icon svgClasses="w-6 h-6" icon="UserIcon" class="mr-2" />
          <span class="font-medium text-lg leading-none">{{$t(`PROFILEVIEW.profileUser`)}}</span>
        </div>
        <vs-divider />
      </div>
      <vs-row>
        <vs-col class="pr-0 md:pr-2" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="12" vs-lg="6">
          <vs-row>
            <vs-col class="mb-5" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
              <Header v-model="avatar" :email="email" :dataUser="dataUser" />
            </vs-col>
          </vs-row>
        </vs-col>

        <vs-col class="pl-0 md:pl-2" vs-type="flex" vs-justify="center" vs-align="start" vs-sm="12" vs-lg="6">
          <vs-row>
            <vs-col class="mb-5" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
              <div class="w-full">
                <vs-input
                  v-model="user.name"
                  v-validate="'required'"
                  name="name"
                  class="w-full"
                  :label="$t(`PROFILEVIEW.name`)"
                  :placeholder="$t(`PROFILEVIEW.enterName`)"
                />
                <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first("name") }}</span>
              </div>
            </vs-col>
            <vs-col class="mb-5" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
              <div class="w-full">
                <vs-input
                  v-model="user.lastname"
                  v-validate="'required'"
                  name="lastname"
                  class="w-full"
                  :label="$t(`PROFILEVIEW.lastname`)"
                  :placeholder="$t(`PROFILEVIEW.enterLastname`)"
                />
                <span class="text-danger text-sm" v-show="errors.has('lastname')">{{ errors.first("lastname") }}</span>
              </div>
            </vs-col>
            <vs-col class="mb-5" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
              <div class="w-full">
                <vs-input
                  disabled
                  v-model="user.companyName"
                  class="w-full"
                  :label="$t(`PROFILEVIEW.company`)"
                  :placeholder="$t(`PROFILEVIEW.enterCompany`)"
                />
              </div>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>

      <vs-row>
        <vs-col class="pr-0 md:pr-2" vs-sm="12" vs-lg="6">
          <vs-row>
            <vs-col class="mb-5 hidden md:block" vs-w="12">
              <div class="w-full">
                <label class="vs-input--label">{{$t(`PROFILEVIEW.department`)}}</label>
                <v-select
                  @input="
                    getCities(user.departmentID);
                    user.cityID = '';
                  "
                  v-model="user.departmentID"
                  :reduce="departament => departament.key"
                  label="departament"
                  :clearable="false"
                  :options="listDepartaments"
                  v-validate="'required'"
                  name="departmentID"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                />
                <span class="text-danger text-sm" v-show="errors.has('departmentID')">{{
                  errors.first("departmentID")
                }}</span>
              </div>
            </vs-col>
            <vs-col class="mb-5 hidden md:block" vs-w="12">
              <div class="w-full">
                <label class="vs-input--label">{{$t(`PROFILEVIEW.city`)}}</label>
                <v-select
                  :reduce="city => city.key"
                  label="city"
                  v-model="user.cityID"
                  :clearable="false"
                  :options="listCities"
                  v-validate="'required'"
                  name="cityID"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                />
                <span class="text-danger text-sm" v-show="errors.has('cityID')">{{ errors.first("cityID") }}</span>
              </div>
            </vs-col>
          </vs-row>
        </vs-col>

        <vs-col class="pl-0 md:pl-2" vs-sm="12" vs-lg="6">
          <vs-row>
            <vs-col class="mb-5" vs-w="12">
              <div class="w-full">
                <vs-input
                  disabled
                  v-model="user.roleName"
                  class="w-full"
                  :label="$t(`PROFILEVIEW.rol`)"
                  :placeholder="$t(`PROFILEVIEW.enterRol`)"
                />
              </div>
            </vs-col>
            <vs-col class="mb-5" vs-w="12">
              <div class="w-full">
                <label class="vs-input--label">{{$t(`PROFILEVIEW.local`)}}</label>
                <v-select
                  :reduce="local => local.key"
                  label="local"
                  v-model="user.localeID"
                  :clearable="false"
                  :options="listLocales"
                  v-validate="'required'"
                  name="local"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                />
                <span class="text-danger text-sm" v-show="errors.has('local')">{{ errors.first("local") }}</span>
              </div>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>

      <vs-row>
        <vs-col class="mb-5 block md:hidden" vs-w="12">
          <div class="w-full">
            <label class="vs-input--label">{{$t(`PROFILEVIEW.department`)}}</label>
            <v-select
              @input="
                getCities(user.departmentID);
                user.cityID = '';
              "
              v-model="user.departmentID"
              :reduce="departament => departament.key"
              label="departament"
              :clearable="false"
              :options="listDepartaments"
              v-validate="'required'"
              name="departmentID"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
            <span class="text-danger text-sm" v-show="errors.has('departmentID')">{{
              errors.first("departmentID")
            }}</span>
          </div>
        </vs-col>
        <vs-col class="mb-5 block md:hidden" vs-w="12">
          <div class="w-full">
            <label class="vs-input--label">{{$t(`PROFILEVIEW.city`)}}</label>
            <v-select
              :reduce="city => city.key"
              label="city"
              v-model="user.cityID"
              :clearable="false"
              :options="listCities"
              v-validate="'required'"
              name="cityID"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
            <span class="text-danger text-sm" v-show="errors.has('cityID')">{{ errors.first("cityID") }}</span>
          </div>
        </vs-col>
        <vs-col class="pr-0 md:pr-2" vs-sm="12" vs-lg="12">
          <MapGeo v-model="user" />
        </vs-col>

        <vs-col vs-type="flex" vs-justify="flex-end" class="pr-0 md:pr-2" vs-sm="12" vs-lg="12">
          <vs-button class="w-full md:w-1/2" color="success" type="border" @click="validate">{{$t(`PROFILEVIEW.update`)}}</vs-button>
        </vs-col>
      </vs-row>
    </vx-card>
  </div>
</template>

<script>
import Api from "@/helpers/api";
import indexedDB from "@/helpers/IndexedDB";
import { user as USUARIO } from "@/provider/dataUser.js";
import vSelect from "vue-select";
import { loading, closeLoding, notify } from "@/helpers/$vs.js";
import Utils from "@/helpers/Utils.js";

import { firebaseInstance as firebase } from "@/main";

import { Validator } from "vee-validate";
import Avatar from "./avatar.vue";
import Header from "./header.vue";
import MapGeo from "./mapGeo.vue";
import { ES, EN, PT } from "./i18n/validate-profile.js";

export default {
  components: { vSelect, Avatar, Header, MapGeo },
  data() {
    return {
      avatar: this.$store.state.user.picture,
      avatar_tem: this.$store.state.user.picture,
      listCities: [],
      listDepartaments: [],
      listLocales: [],
      key: "",
      password: "",
      password_repeat: "",
      message_error_pass: "Los passwords no coinciden.",
      link_reset_pass: "",
      url_tem_avatar: "",
      name_avatar: "",
      user: {
        name: "",
        lastname: "",
        address: "",
        companyID: "",
        roleID: "",
        cityID: "",
        departmentID: "",
        localeID: "",
        picture: "",
        latitude: "",
        longitude: ""
      },
      options: {
        draggable: true,
        onDragend: (address, coords) => {
          loading("default", "#div-with-loading");
          this.user.latitude = parseFloat(coords.lat);
          this.user.longitude = parseFloat(coords.lng);
          this.reversed(coords.lat, coords.lng);
        }
      },
      locale: {
        es: ES,
        en: EN,
        pt: PT
      }
    };
  },
  methods: {
    async validate() {
      const result = await this.$validator.validateAll();
      if (result) this.updateUser(null);
      else notify("Usuario", "Faltan campos por completar", "warning");
    },
    async updateUser(image = null) {
      try {
        loading();
        if (this.url_tem_avatar !== "" && this.avatar !== null && this.avatar.length > 0 && Utils.isBase64(this.avatar)) {
          await this.updateAvatar();
          return;
        }
        this.url_tem_avatar = this.avatar;
        if (image !== null) this.user.picture = image;
        
        await Api.put("/users/" + this.key, this.user);
        notify("Usuario", "Usuario actualizado correctamente.", "success", "bottom-right", "icon-user");

        const local = this.listLocales.find(local => local.key === this.user.localeID).local;
        const locales = {
          'Francés': 'fr',
          'Inglés': 'en',
          'Español': 'es',
          'Portugués': 'pt'
        }

        this.$i18n.locale = locales[local];

        let user = { ...this.$store.state.user, ...this.user };

        this.$store.commit("SET_DATA_USER", { ...user });
        const userIndexedDB = await USUARIO();
        const newData = { ...userIndexedDB, ...this.user };
        indexedDB.put("users", newData, this.$store.state.user.uuid);
        this.name_avatar = "";
        this.resetData();
      } catch (error) {
        console.log("error profile: updateUser", error);
      } finally {
        closeLoding();
      }
    },
    async updateAvatar() {
      const file = this.avatar;
      const storageRef = firebase.storage().ref();
      const key = this.$store.state.user.key;
      const uploadTask = storageRef.child(`Avatars/${key}`).putString(file, "data_url", { contentType: "image/png" });
      await uploadTask.on(
        "state_changed",
        async snapshot => {
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        error => {
          console.log("Error ", error);
        },
        async () => {
          const url = await uploadTask.snapshot.ref.getDownloadURL();
          // this.avatar = "";
          this.url_tem_avatar = "";
          this.updateUser(url);
        }
      );
    },
    async getDepartaments() {
      try {
        const result = await Api.get("/departments");
        this.listDepartaments = result.data.map(departament => ({
          departament: departament.name,
          dane: departament.dane,
          key: departament.key
        }));
      } catch (error) {
        console.log("Error: getCities", error);
      }
    },
    async getCities(key) {
      try {
        const { dane } = this.listDepartaments.find(departament => departament.key === key);
        const result = await Api.get(`/departments/${dane}/cities`);
        this.listCities = result.data.map(city => ({
          city: city.name,
          key: city.key
        }));
      } catch (error) {
        this.listCities = [];
        console.log("Error: getCities", error);
      }
    },
    async getLocale() {
      try {
        const result = await Api.get("/locales");
        this.listLocales = result.data.map(local => ({
          local: this.$t(`LOCALES.${local.name}`),
          key: local.key
        }));
      } catch (error) {
        console.log("Error: getCities", error);
      }
    },
    initMap({ lat, lng }) {
      Anuket.run("_map", {
        zoom: 18,
        initMarker: true,
        latlng: {
          lat: lat,
          lng: lng
        }
      });
      Anuket.addMarker({ lat: lat, lng: lng }, this.options);
    },
    async reversed(latitude, longitude) {
      try {
        const data = { latitude, longitude };
        const result = await Api.post("/reversed", data);
        const address = `${result.data.address} ${result.data.city}, ${result.data.department}`;
        this.user.address = address;
      } catch (error) {
        console.log("Error: reversed", error);
      } finally {
        closeLoding("div-with-loading");
      }
    },
    resetData() {
      this.key = this.$store.state.user.userID;
      this.user = {
        name: this.$store.state.user.name,
        lastname: this.$store.state.user.lastname,
        roleName: this.$store.state.user.roleName,
        address: this.$store.state.user.address,
        companyID: this.$store.state.user.companyID,
        companyName: this.$store.state.user.companyName,
        roleID: this.$store.state.user.roleID,
        cityID: this.$store.state.user.cityID,
        departmentID: this.$store.state.user.departmentID,
        localeID: this.$store.state.user.localeID,
        picture: this.$store.state.user.picture,
        latitude: this.$store.state.user.latitude || 4.672444194458983,
        longitude: this.$store.state.user.longitude || -74.06386457431061
      };
      this.url_tem_avatar = this.$store.state.user.picture;
      this.avatar = this.$store.state.user.picture;
    }
  },
  computed: {
    dataUser() {
      return {
        name: this.user.name,
        lastname: this.$store.state.user.lastname,
        roleName: this.$store.state.user.roleName
      };
    },
    email() {
      return this.$store.state.user.email;
    },
    hasAvatar() {
      return (
        this.url_tem_avatar ||
        "https://firebasestorage.googleapis.com/v0/b/servi-forms.appspot.com/o/Avatars%2Fuser.svg?alt=media&token=2ed96239-43cc-46c6-939f-d7888c7f8f1c"
      );
    }
  },
  async mounted() {
    Validator.localize(this._i18n.locale, this.locale[this._i18n.locale]);
    this.resetData();
    await this.getDepartaments();
    await this.getCities(this.$store.state.user.departmentID);
    await this.getLocale();
    setTimeout(() => {
      let coords = { lat: this.user.latitude, lng: this.user.longitude };
      this.initMap(coords);
    }, 200);
  },
  watch: {
    "_i18n.locale": function (value) {
      Validator.localize(value, this.locale[value]);
    }
  },
};
</script>

<style lang="scss">
.list-form {
  background: rgba(230, 230, 230, 0.2);
  height: calc(100% - 55px);
}
</style>

<style lang="scss" scoped>
#profile {
  position: relative;
  .border-gray-100 {
    border-color: rgba(229, 231, 235, 1);
  }

  .border-gray-200 {
    border-color: rgba(209, 213, 219, 1);
  }

  .bg-grey-200 {
    background: rgba(209, 213, 219, 0.3);
  }

  .btn_avatar:hover {
    background: rgba(255, 71, 87, 0.8) !important;
  }
}
</style>
